import { request } from '@/utils/request.js'

export async function getCompanyAlpha(companyId, params, signal) {
    params = { ...params }

    if (params.startDate?.toISOString) {
        params.startDate = params.startDate.toISOString()
    }

    if (params.endDate?.toISOString) {
        params.endDate = params.endDate.toISOString()
    }

    const result = await request.get(`/api/alpha/companies/${companyId}`, params, {
        signal,
    })

    // we're switching this to be called "daily" instead of "alpha" in the response
    result.daily ??= result.alpha ?? []

    return result
}
